
export const getAppLoadingState = state => state.components.app.loading;

export const getAppOverlayState = state => state.components.app.overlayActive;

export const getAppScrollPos = state => state.components.app.currentScrollPos;
